import { createSlice } from '@reduxjs/toolkit';

export interface KeycloakAccount {
  id: string;
  login: string;
  firstName: string;
  lastName: string;
  email: string;
  imageUrl: string | null;
  activated: boolean;
  langKey: string;
  createdBy: string | null;
  createdDate: string | null;
  lastModifiedBy: string | null;
  lastModifiedDate: string | null;
  authorities: string[];
}

interface AuthState {
  isAuthenticated: boolean;
  account: KeycloakAccount | null;
  sessionHasBeenFetched: boolean;
  loading: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
  account: null,
  sessionHasBeenFetched: false,
  loading: false,
};

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    updateAuth: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated ?? false;
      state.account = action.payload.account ?? null;
      state.sessionHasBeenFetched = action.payload.sessionHasBeenFetched ?? false;
    },
    clearAuth: state => {
      state.isAuthenticated = false;
      state.account = null;
      state.sessionHasBeenFetched = false;
    },
  },
});

export const { updateAuth, clearAuth } = authenticationSlice.actions;

export default authenticationSlice.reducer;
